import React from "react";
import {
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaLocationArrow,
  FaPhoneAlt,
  FaTwitter,
} from "react-icons/fa";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

function Contact() {
  return (
    <div>
      <Navbar />

      <div className="antialiased">
        <div className="flex w-full min-h-screen justify-center items-center pb-[4rem]">
          <div className="flex flex-col md:flex-row md:space-x-6 md:space-y-0 space-y-6 text-green-900 w-full max-w-4xl p-8 sm:p-12 rounded-xl shadow-lg text-white overflow-hidden">
            <div className="flex flex-col space-y-8 justify-between">
              <div>
                <h1 className="font-bold text-4xl tracking-wide">Contact Us</h1>
                <p className="pt-2 text-cyan-100 text-sm">
                  Our support team is quick to reply and is fluent in
                  Portuguese, English and Spanish.
                </p>
              </div>
              <div className="inline-flex space-x-2 items-center">
                <FaPhoneAlt className="text-teal-300 text-xl" />
                <span>+(123) 456 7890</span>
              </div>
              <div className="inline-flex space-x-2 items-center">
                <FaEnvelope className="text-teal-300 text-xl" />
                <span>contact@AGROVESTinvest00@gmail.com</span>
              </div>

              <div className="flex space-x-4 text-lg">
                <FaFacebook />
                {/* <FaTwitter/>
              <FaLinkedin/> */}
                <FaInstagram />
              </div>
            </div>

            <div className="relative">
              <div className="absolute z-0 w-40 h-40 bg-teal-400 rounded-full -right-28 -top-28"></div>
              <div className="absolute z-0 w-40 h-40 bg-teal-400 rounded-full -left-28 -bottom-16"></div>
              <div className="relative z-0 bg-white rounded-xl shadow-lg p-8 text-gray-600 md:w-80">
                <form action="" className="flex flex-col space-y-4">
                  <div>
                    <label className="text-sm ">Your Name</label>
                  </div>

                  <div>
                    <input
                      type="text"
                      placeholder="Your Name"
                      className="ring-1 ring-gray-300 w-full rounded-md px-4 py-2 mt-2 outline-none focus:ring-2 focus:ring-teal-300 "
                    />
                  </div>

                  <div>
                    <label className="text-sm ">Email Address</label>
                  </div>

                  <div>
                    <input
                      type="email"
                      placeholder="Email Address"
                      className="ring-1 ring-gray-300 w-full rounded-md px-4 py-2 mt-2 outline-none focus:ring-2 focus:ring-teal-300 "
                    />
                  </div>

                  <div>
                    <label className="text-sm ">Message</label>

                    <textarea
                      placeholder="Message"
                      rows="4"
                      className="ring-1 ring-gray-300 w-full rounded-md px-4 py-2 mt-2 outline-none focus:ring-2 focus:ring-teal-300 "
                    ></textarea>
                  </div>

                  <button className="inline-block self-end bg-cyan-700 text-white font-bold rounded-lg px-6 py-2 uppercase text-sm">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;
